<template>
  <div>
    <!-- <div class="header">
      <span class="home"><router-link class="home" to="/">{{$t(`userDrawer.data[0].name`)}}  </router-link> > 个人中心 > 我的订单 ></span>申请退款
    </div> -->
    <div class="refund">
      <order-goods :cartInfo="orderInfo"></order-goods>
      <div class="lines"></div>
      <!-- <client-only> -->
        <el-form ref="form" :model="form" label-width="100px" :rules="rules" label-position="right">
          <div class="cont">
            <!-- 退款类型 -->
            <el-form-item :label="$t(`page.users.goodsReturn.refundType`) + '：'" prop="refund_type">
              <el-radio-group v-model="form.refund_type">
                <el-radio :label="1">{{ $t('page.users.goodsReturn.type1') }}</el-radio>
                <el-radio :label="2">{{ $t('page.users.goodsReturn.type2') }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t(`page.users.goodsReturn.reason`)+ '：'" class="item-border" prop="text">
              <el-select v-model="form.text" :placeholder="$t(`page.users.goodsReturn.reason`)" class="lang">
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item, index) in refundArray"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t(`page.users.goodsReturn.info`)+ '：'">
              <el-input
                type="textarea"
                :placeholder="$t(`page.users.goodsReturn.place`)"
                :autosize="{ minRows: 4 }"
                maxlength="100"
                show-word-limit
                v-model="form.refund_reason_wap_explain"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t(`page.users.goodsReturn.upload`)+ '：'">
              <div class="img-box-wrapper">
                <upload-from @picList="picList"></upload-from>
              </div>
              <div class="tip">
                {{$t(`message.tips.picTips`)}}
              </div>
            </el-form-item>
            <div class="lines" style="margin-top: 18px"></div>
          </div>
          <el-form-item>
            <el-button type="primary" :disabled="isDialog" @click="onSubmit('form')">{{$t(`page.users.goodsReturn.submit`)}}</el-button>
          </el-form-item>
        </el-form>
      <!-- </client-only> -->
    </div>

  </div>
</template>

<script>
  import orderGoods from "@/components/orderGoods";
  import { Debounce } from '@/utils/validate.js'
  import uploadFrom from "@/components/upload";
    export default {
      name: "refund_confirm",
      data() {
          return {
            form: {
              text: "",
              refund_reason_wap_explain: "",
              refund_reason_wap_img: '',
              orderNo: '',
              refund_type: 1 // 1: 仅退款, 2: 退货退款
            },
            upLoadUrl: process.env.BASE_URL + "/api/front/upload/image",
            myHeaders: {},
            pics: [],
            rules: {
              refund_type: [
                { required: true, message: this.$t(`page.users.goodsReturn.validateType`), trigger: 'change' }
              ],
              text: [
                { required: true, message: this.$t(`page.users.goodsReturn.reason`), trigger: 'change' }
              ]
            },
            isDialog: false,
            orderInfo: {},
            refundArray: [],
            order_sub_id: '',
            content_id: '',
            id: '',
          }
      },
      components: { orderGoods, uploadFrom },
      // async asyncData({ app, query }) {
      //   let [refundInfo, refundArray] = await Promise.all([
      //     app.$axios.get(`/api/front/order/apply/refund/${query.orderNo}`),
      //     app.$axios.get('/api/front/order/refund/reason')
      //   ]);
      //   return {
      //     orderInfo: refundInfo.data,
      //     refundArray: refundArray.data,
      //     orderNo: query.orderNo
      //   }
      // },
      head() {
        return {
          title: this.$t(`page.orderDetails.refund`)
        }
      },
      created() {
        const orderInfo = this.$route.params.orderInfo;
        this.orderInfo = orderInfo;
        this.form.orderNo = this.$route.query.orderNo;
        this.orderNo = this.$route.query.orderNo;
        this.content_id = this.$route.query.content_id; // 商品id
        this.order_sub_id = this.$route.query.order_sub_id // 子订单id
        this.id = this.$route.query.id // 订单id
        
        // 从 i18n 获取退款原因
        this.refundArray = this.$t('page.users.goodsReturn.reasons') || [];

        // this.getDetail()
      },
      methods: {
        picList(item){
          this.pics = item
        },
        // 获取售后详情
        getDetail() {
          this.$axios.post('/api/center/getsonOrder', {
            id: this.content_id
          }).then(res => {
            console.log(res, 'detail')
          })
        },
        onSubmit: Debounce(function (formName) {
          let that = this;
          that.$refs[formName].validate((valid) => {
            if (valid) {
              // 从 orderInfo 数组中获取第一个商品的价格和数量
              const price = that.orderInfo && that.orderInfo[0] ? that.orderInfo[0].price : 0;
              const num = that.orderInfo && that.orderInfo[0] ? that.orderInfo[0].num : 0;
              // 计算退款金额并保留两位小数
              const refundAmount = (price * num).toFixed(2);
              
              const data = {
                type: that.form.refund_type, // 1 退款 2退货退款
                reason: that.form.text, // 退款原因
                img: that.pics.join(','),
                desc: that.form.refund_reason_wap_explain, // 退款说明
                refund_amount: refundAmount,
                content_id: that.content_id,
                order_sub_id: that.order_sub_id,
                id: that.id,
              }
              that.$axios
                .post("/api/center/applyOrderRefund", data)
                .then(res => {
                  that.isDialog = true;
                  that.$message.success(that.$t(`message.login.operationSU`));
                  that.$router.push({ path: '/users/after_sale?activeName=1' });
                })
            } else {
              return false;
            }
          })
          }
        ),
      }
  }
</script>

<style lang="scss" scoped>
  .lang{
    width: 400px;
  }
  .header {
    height: 60px;
    line-height: 60px;
    color: #999999;
    .home {
      color: #282828;
    }
  }
  .lines{
    border: 1px dashed #e1e1e1;
  }
  .refund {
    background: #ffffff;
  }
  .el-form {
    .cont {
      padding: 30px;
    }
    .item-price{
      ::v-deep input{
        padding-right: 0;
      }
    }
    .item-desc{
      color: #B5B5B5;
    }
    .item-border{
    //  padding-bottom: 25px;
    }
    > .el-form-item {
      margin-top: 10px;
      margin-bottom: 0;
      padding-bottom: 30px;
      padding-right: 30px;
      text-align: right;
    }
    .el-textarea {
      width: 820px;
    }
    ::v-deep.el-form-item__label{
      font-size: 14px;
      color: #666666;
    }
    ::v-deep.el-textarea__inner {
      border: none;
      background: #f7f7f7;
    }
    ::v-deep.el-upload--picture-card {
      width: 100px;
      height: 100px;
      border-style: solid;
      line-height: 100px;
    }
    ::v-deep.el-upload-list--picture-card .el-upload-list__item {
      width: 100px;
      height: 100px;
    }
  }
</style>
